export default "__VITE_ASSET__BQSBwt43__"